/**
 * Model for search events
 */
export default class SearchEventsModel {
  /**
   * Class constructor method
   * @param data
   */
  constructor({
    an = '',
    bid = 0,
    cn = '',
    hn = '',
    md = '',
    mid = 0,
    mt = 0,
    sc = '',
    si = 0,
    sn = '',
    t = '',
    tn = '',
    tid = 0,
  }) {
    /**
     * Away team name
     * @type {string}
     */
    this.awayTeam = an;
    /**
     * Home team name
     * @type {string}
     */
    this.homeTeam = hn;
    /**
     * Betradar id
     * @type {number}
     */
    this.betradarId = bid;
    /**
     * Match id
     * @type {number}
     */
    this.matchId = mid;
    /**
     * Match type can be P - prematch or L - live
     * @type {string}
     */
    this.matchType = t;
    /**
     * Category name
     * @type {string}
     */
    this.categoryName = cn;
    /**
     * Tournament name
     */
    this.tournamentName = tn;
    /**
     * Tournament Id
     */
    this.tournamentId = tid;
    /**
     * Match time / date
     */
    this.matchTime = mt;
    /**
     * Score, only for live matches
     * @type {string}
     */
    this.score = sc;
    /**
     * Sport id
     * @type {number}
     */
    this.sportId = si;
    /**
     * Sport name
     * @type {string}
     */
    this.sportName = sn;
    /**
     * Match date
     */
    this.matchDate = md;

    this.setMatchName();
    this.setSearchField();
  }

  /**
   * Set match name
   */
  setMatchName() {
    this.matchName = `${this.homeTeam} - ${this.awayTeam}`;
  }

  /**
   * Set another property to each object used for searching
   */
  setSearchField() {
    this.searchField = `${this.homeTeam} - ${this.awayTeam} - ${this.categoryName} - ${this.tournamentName}`;
  }
}
